import React from 'react';
import { Icon, IconName } from 'components/Icon/Icon';
import Text from 'components/Text/Text';

interface IProps {
	fileName: string;
	testId: string;
	onDownload?: () => void;
	onDelete?: () => void;
}

export const FileField: React.FC<IProps> = ({ fileName, testId, onDownload, onDelete }) => (
	<div
		className="h-10 px-4 border border-solid border-grey-10-new rounded flex items-center gap-1 bg-white-00-new"
		data-test={testId}>
		<Icon name={IconName.file} size="lg" className="shrink-0 text-purple-07-new" />
		<Text className="min-w-0 flex-1" translationKey={fileName} withTooltip={true} isNewTooltip={true} />
		{onDownload && (
			<Icon
				name={IconName.download}
				size="lg"
				className="shrink-0 cursor-pointer text-purple-07-new"
				onClick={onDownload}
			/>
		)}
		{onDelete && (
			<Icon
				name={IconName.delete}
				size="lg"
				className="shrink-0 cursor-pointer text-red-06-new"
				onClick={onDelete}
			/>
		)}
	</div>
);
